import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Table, TableBody, TableCell, TableHead, TableRow, Box, Typography, Chip,
} from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';

// shortcuts: array of { key, ctrl, shift, description }
export default function KeyboardShortcutsHelp({ open, onClose, shortcuts = [] }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <KeyboardIcon />
          <Typography variant="h6" fontWeight={700}>Keyboard Shortcuts</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Shortcut</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shortcuts.filter(s => s.description).map((s, i) => (
              <TableRow key={i} hover>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
                    {s.ctrl && <Chip label="Ctrl" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }} />}
                    {s.shift && <Chip label="Shift" size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }} />}
                    <Chip
                      label={s.key === '?' ? '?' : s.key.toUpperCase()}
                      size="small"
                      color="primary"
                      sx={{ fontFamily: 'monospace', fontWeight: 700 }}
                    />
                  </Box>
                </TableCell>
                <TableCell>{s.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
